/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2022-08-19 10:34:28
 * @Description: 消防维保管理服务
 */
/* =============================================
   业务功能路由配置文件引入start
  *
  *
*/
// 维保项目管理
import wbxmRoutes from '@/features/xfwbgl/wbxm/wbxm.routes.js';
// 维保计划管理
import wbjhRoutes from '@/features/xfwbgl/wbjh/wbjh.routes.js';
// 维保建筑管理
import wbjzRoutes from '@/features/xfwbgl/wbjz/wbjz.routes.js';

// 维保合同
import wbhtRoutes from '@/features/xfwbgl/wbht/wbht.routes.js';

// 维保签到
import wbqdRoutes from '@/features/xfwbgl/wbqd/wbqd.routes.js';

// // 维保报告信息
// import wbbgRoutes from '@/features/xfwbgl/bggl/wbbg.routes.js';

// 巡查测试登记
import xccsdjRoutes from '@/features/xfwbgl/xccsdj/xccsdj.routes.js';

// 代办报告项目
import dbbgRoutes from '@/features/xfwbgl/dbbg/dbbg.routes.js';

// 报告管理
import bgglRoutes from '@/features/xfwbgl/bggl/bggl.routes.js';
// 维保项目管理
import gzwxRoutes from '@/features/xfwbgl/gzwx/gzwx.routes.js';
/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  wbxmRoutes, wbhtRoutes, wbqdRoutes, xccsdjRoutes, dbbgRoutes, wbjhRoutes, wbjzRoutes, bgglRoutes, gzwxRoutes
];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const xfwbglRoutes = {
  path: 'xfwbgl',
  name: 'xfwbgl',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default xfwbglRoutes;
